import { DashboardLayout } from "@/components";
import { authMiddleware } from "@/middleware";
import { SellerRelationsPage } from "@/pages/relations";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_market/relations/seller")({
	component: () => (
		<DashboardLayout>
			<SellerRelationsPage />
		</DashboardLayout>
	),
	loader: authMiddleware,
});
